import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdditionalQuestionsService } from '@services/dws/additional-questions.service';
import { AdditionalQuestionsPopupComponent } from '@web/app/components/dialogs/additional-questions-popup/additional-questions-popup.component';

@Component({
  selector: 'web-reservation-additional-questions-action',
  templateUrl: './reservation-additional-questions-action.component.html',
  styleUrls: ['./reservation-additional-questions-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReservationAdditionalQuestionsActionComponent implements OnChanges {
  @Input() reservationId?: string;
  @Input() display: 'menu' | 'quick' = 'quick';

  hasAdditionalQuestionAnswers = false;

  constructor(
    private additionalQuestionsService: AdditionalQuestionsService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['reservationId']) {
      this.loadHasAnswersFlag();
    }
  }

  loadHasAnswersFlag(): void {
    this.hasAdditionalQuestionAnswers = false;
    if (!this.reservationId) {
      this.cdr.markForCheck();
      return;
    }

    this.additionalQuestionsService.listReservationAnswers(this.reservationId).subscribe(
      (answers) => {
        this.hasAdditionalQuestionAnswers = (answers?.length || 0) > 0;
        this.cdr.markForCheck();
      },
      () => {
        this.hasAdditionalQuestionAnswers = false;
        this.cdr.markForCheck();
      }
    );
  }

  additionalQuestionsClicked(): void {
    if (!this.reservationId) {
      return;
    }
    this.dialog.open(AdditionalQuestionsPopupComponent, {
      width: '520px',
      maxWidth: '95vw',
      panelClass: 'additional-questions-dialog',
      data: { reservationId: this.reservationId },
    });
  }
}
